export default {
  CONN_DEVICE: {
    id: 'CONN_DEVICE',
    mainChart: {
      name: '연동 장비',
      rscInfoList: [
        {
          rsctypeId: 'COOPERATION_DEVICE',
          rscId: 'COOPERATION_DEVICE_RESPTIME',
        },
      ],
    },
  },
  CPU_USERATE: {
    id: 'CPU_USERATE',
    mainChart: {
      name: 'CPU 사용률',
      rscInfoList: [
        {
          rsctypeId: 'CPU',
          rscId: 'TOTAL_USERATE',
          rscKey: '_',
        },
        {
          rsctypeId: 'CPU',
          rscId: 'SYS_USERATE',
          rscKey: '_',
        },
        {
          rsctypeId: 'CPU',
          rscId: 'USER_USERATE',
          rscKey: '_',
        },
      ],
    },
    subCharts: [
      {
        id: 'LOADAVG',
        name: '부하 평균',
        rscInfoList: [
          {
            rsctypeId: 'CPU',
            rscId: 'LOADAVG_1M',
            rscKey: '_',
          },
          {
            rsctypeId: 'CPU',
            rscId: 'LOADAVG_5M',
            rscKey: '_',
          },
          {
            rsctypeId: 'CPU',
            rscId: 'LOADAVG_15M',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'WAITIO',
        name: 'Wait I/O',
        rscInfoList: [
          {
            rsctypeId: 'CPU',
            rscId: 'WAITIO',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'QUEUE',
        name: 'Queue 정보',
        rscInfoList: [
          {
            rsctypeId: 'CPU',
            rscId: 'RUNQ',
            rscKey: '_',
          },
          {
            rsctypeId: 'CPU',
            rscId: 'SWAPQ',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'TOTALUSERATE', // rsc_key Top5, except total key
        name: '코어별 CPU 사용률',
        rscInfoList: [
          {
            rsctypeId: 'CPU',
            rscId: 'TOTAL_USERATE',
          },
        ],
      },
    ],
  },
  DISK_IO: {
    id: 'DISK_IO',
    mainChart: {
      name: '디스크 I/O',
      rscInfoList: [
        {
          rsctypeId: 'DISKIO',
          rscId: 'DISKIO_BUSY',
          rscKey: '_',
        },
      ],
    },
    subCharts: [
      {
        id: 'AVQUEUE',
        name: '평균 전송 요청 수',
        rscInfoList: [
          {
            rsctypeId: 'DISKIO',
            rscId: 'DISKIO_AVQUEUE',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'RW_S',
        name: '입출력 수',
        rscInfoList: [
          {
            rsctypeId: 'DISKIO',
            rscId: 'DISKIO_RW_S',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'BLK_S',
        name: '블록 수',
        rscInfoList: [
          {
            rsctypeId: 'DISKIO',
            rscId: 'DISKIO_BLK_S',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'DISKIO_AV',
        name: '평균 대기/처리 시간',
        rscInfoList: [
          {
            rsctypeId: 'DISKIO',
            rscId: 'DISKIO_AV_WAIT',
            rscKey: '_',
          },
          {
            rsctypeId: 'DISKIO',
            rscId: 'DISKIO_AV_SERV',
            rscKey: '_',
          },
        ],
      },
    ],
  },
  DISK_USERATE: {
    id: 'DISK_USERATE',
    mainChart: {
      name: '디스크 사용률',
      rscInfoList: [
        // rsc_key Top5, except total key
        {
          rsctypeId: 'DISK',
          rscId: 'DISK_USERATE',
        },
      ],
    },
  },
  FILTER_LOG: {
    id: 'FILTER_LOG',
    mainChart: {
      name: '필터링 로그',
      rscInfoList: [
        {
          rsctypeId: 'APPLOG',
          rscId: 'UNCHECKED_ERROR_APPLOG',
          rscKey: '_',
        },
      ],
    },
  },
  MEM_USERATE: {
    id: 'MEM_USERATE',
    mainChart: {
      name: '메모리 사용률',
      rscInfoList: [
        {
          rsctypeId: 'MEM_PHY',
          rscId: 'USERATE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MEM_SWP',
          rscId: 'USERATE',
          rscKey: '_',
        },
      ],
    },
    subCharts: [
      {
        id: 'MEM_PHY',
        name: '물리 메모리',
        rscInfoList: [
          {
            rsctypeId: 'MEM_PHY',
            rscId: 'TOTSIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'MEM_PHY',
            rscId: 'USEDSIZE',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'MEM_SWP',
        name: '스왑 메모리',
        rscInfoList: [
          {
            rsctypeId: 'MEM_SWP',
            rscId: 'TOTSIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'MEM_SWP',
            rscId: 'USEDSIZE',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'FREERATE',
        name: 'Free 메모리',
        rscInfoList: [
          {
            rsctypeId: 'MEM_PHY',
            rscId: 'FREERATE',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'CACHERATE',
        name: '캐시 메모리',
        rscInfoList: [
          {
            rsctypeId: 'MEM_PHY',
            rscId: 'CHCHESIZE',
            rscKey: '_',
          },
        ],
      },
    ],
  },
  NET_IO: {
    id: 'NET_IO',
    mainChart: {
      name: '네트워크 I/O',
      rscInfoList: [
        {
          rsctypeId: 'NETIO',
          rscId: 'NETIO_BPS_IN',
          rscKey: '_',
        },
        {
          rsctypeId: 'NETIO',
          rscId: 'NETIO_BPS_OUT',
          rscKey: '_',
        },
      ],
    },
    subCharts: [
      {
        id: 'PKT',
        name: '패킷 수',
        rscInfoList: [
          {
            rsctypeId: 'NETIO',
            rscId: 'NETIO_PKT_IN',
            rscKey: '_',
          },
          {
            rsctypeId: 'NETIO',
            rscId: 'NETIO_PKT_OUT',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'ERRPKT',
        name: '에러 패킷 수',
        rscInfoList: [
          {
            rsctypeId: 'NETIO',
            rscId: 'NETIO_ERRPKT_IN',
            rscKey: '_',
          },
          {
            rsctypeId: 'NETIO',
            rscId: 'NETIO_ERRPKT_OUT',
            rscKey: '_',
          },
        ],
      },
    ],
  },
  OS_PERF: {
    id: 'OS_PERF',
    mainChart: {
      name: 'OS 성능',
      rscInfoList: [
        {
          rsctypeId: 'OSTABLE',
          rscId: 'OSTABLE_PROC_CUR',
          rscKey: '_',
        },
        {
          rsctypeId: 'OSTABLE',
          rscId: 'OSTABLE_INODE_CUR',
          rscKey: '_',
        },
        {
          rsctypeId: 'OSTABLE',
          rscId: 'OSTABLE_FILEH_CUR',
          rscKey: '_',
        },
      ],
    },
    subCharts: [
      {
        id: 'OSBUF_BDS',
        name: '블록장치 전송률',
        rscInfoList: [
          {
            rsctypeId: 'OSBUFFER',
            rscId: 'OSBUF_BDS_READ',
            rscKey: '_',
          },
          {
            rsctypeId: 'OSBUFFER',
            rscId: 'OSBUF_BDS_WRITE',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'OSBUF_SBS',
        name: '시스템버퍼 전송률',
        rscInfoList: [
          {
            rsctypeId: 'OSBUFFER',
            rscId: 'OSBUF_SBS_READ',
            rscKey: '_',
          },
          {
            rsctypeId: 'OSBUFFER',
            rscId: 'OSBUF_SBS_WRITE',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'OSBUF_ODS',
        name: '외부장치 전송률',
        rscInfoList: [
          {
            rsctypeId: 'OSBUFFER',
            rscId: 'OSBUF_ODS_READ',
            rscKey: '_',
          },
          {
            rsctypeId: 'OSBUFFER',
            rscId: 'OSBUF_ODS_WRITE',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'OSBUF_BCA',
        name: '버퍼 캐시 적중률',
        rscInfoList: [
          {
            rsctypeId: 'OSBUFFER',
            rscId: 'OSBUF_BCA_READ',
            rscKey: '_',
          },
          {
            rsctypeId: 'OSBUFFER',
            rscId: 'OSBUF_BCA_WRITE',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'IPC',
        name: 'IPC',
        rscInfoList: [
          {
            rsctypeId: 'IPC',
            rscId: 'MESSAGEQUEUE_COUNT',
            rscKey: '_',
          },
          {
            rsctypeId: 'IPC',
            rscId: 'SHAREDMEM_COUNT',
            rscKey: '_',
          },
          {
            rsctypeId: 'IPC',
            rscId: 'SEMAPHORE_COUNT',
            rscKey: '_',
          },
        ],
      },
    ],
  },
  PAGE: {
    id: 'PAGE',
    mainChart: {
      name: 'Page',
      rscInfoList: [
        {
          rsctypeId: 'PAGE',
          rscId: 'PAGE_SCAN',
          rscKey: '_',
        },
        {
          rsctypeId: 'PAGE',
          rscId: 'PAGE_OUT',
          rscKey: '_',
        },
        {
          rsctypeId: 'PAGE',
          rscId: 'PAGE_FREE',
          rscKey: '_',
        },
      ],
    },
  },
  PROCESS: {
    id: 'PROCESS',
    mainChart: {
      name: '프로세스',
      rscInfoList: [
        {
          rsctypeId: 'PROCSTAT',
          rscId: 'PROC_TOT_COUNT',
          rscKey: '_',
        },
        {
          rsctypeId: 'PROCCOUNT',
          rscId: 'PROC_CPU_MAX_OCCUPY_COUNT',
          rscKey: '_',
        },
        {
          rsctypeId: 'PROCCOUNT',
          rscId: 'PROC_MEM_MAX_OCCUPY_COUNT',
          rscKey: '_',
        },
        {
          rsctypeId: 'PROCSTAT',
          rscId: 'PROC_ZOMBI_COUNT',
          rscKey: '_',
        },
      ],
    },
  },
  SESSION_STATUS: {
    id: 'SESSION_STATUS',
    mainChart: {
      name: '세션 수',
      rscInfoList: [
        {
          rsctypeId: 'SESSIONSTATUS',
          rscId: 'ESTABLISHED_STATUS',
          rscKey: '_',
        },
        {
          rsctypeId: 'SESSIONSTATUS',
          rscId: 'SYN_RCVD_STATUS',
          rscKey: '_',
        },
        {
          rsctypeId: 'SESSIONSTATUS',
          rscId: 'SYN_SENT_STATUS',
          rscKey: '_',
        },
        {
          rsctypeId: 'SESSIONSTATUS',
          rscId: 'FIN_WAIT1_STATUS',
          rscKey: '_',
        },
        {
          rsctypeId: 'SESSIONSTATUS',
          rscId: 'FIN_WAIT2_STATUS',
          rscKey: '_',
        },
        {
          rsctypeId: 'SESSIONSTATUS',
          rscId: 'TIME_WAIT_STATUS',
          rscKey: '_',
        },
        {
          rsctypeId: 'SESSIONSTATUS',
          rscId: 'CLOSE_WAIT_STATUS',
          rscKey: '_',
        },
        {
          rsctypeId: 'SESSIONSTATUS',
          rscId: 'CLOSED_STATUS',
          rscKey: '_',
        },
      ],
    },
    subCharts: [
      {
        id: 'SESSION_CONNECTION_COUNT',
        name: '중요 세션 수',
        rscInfoList: [
          {
            rsctypeId: 'MAJORSESSIONSTAT',
            rscId: 'SESSION_CONNECTION_COUNT',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'PORTSCAN_TOTAL_COUNT',
        name: 'Listen 포트 수',
        rscInfoList: [
          {
            rsctypeId: 'PORTSCANCOUNT',
            rscId: 'PORTSCAN_TOTAL_COUNT',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'PORTSCAN_AUTH_COUNT',
        name: '인증 포트',
        rscInfoList: [
          {
            rsctypeId: 'PORTSCANCOUNT',
            rscId: 'PORTSCAN_AUTH_COUNT',
            rscKey: '_',
          },
          {
            rsctypeId: 'PORTSCANCOUNT',
            rscId: 'PORTSCAN_NO_AUTH_CONNECT_COUNT',
            rscKey: '_',
          },
        ],
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/views/performance/node/analysis/server/perf-chart-type.js